import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import type { Equipment } from "../../../types/equipments";

interface EquipmentAttributeValuesAccordionProps {
  attributeValues: NonNullable<Equipment["attribute_values"]>;
}

export const EquipmentAttributeValuesAccordion = ({
  attributeValues,
}: EquipmentAttributeValuesAccordionProps) => {
  const { t } = useTranslation();

  const rows = Array.isArray(attributeValues) ? attributeValues : [];

  return (
    <Accordion
      variant="outlined"
      disableGutters
      sx={{ maxWidth: 720, borderColor: "divider", "&:before": { display: "none" } }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {t("Configuration")}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <TableContainer component={Paper} variant="outlined" sx={{ border: 0 }}>
          <Table size="small">
            <TableBody>
              {rows.length > 0 ? (
                rows.map((v, idx) => {
                  const attrName = v.attribute_info?.name || String(v.attribute ?? "-");
                  const choiceLabel =
                    v.choice_info?.name ||
                    (v.choice != null ? String(v.choice) : "-");
                  const note = v.note?.trim();
                  const valueText = note ? `${choiceLabel} (${note})` : choiceLabel;
                  return (
                    <TableRow key={`${v.id || idx}`}>
                      <TableCell sx={{ fontWeight: 600, width: "35%" }}>
                        {attrName}
                      </TableCell>
                      <TableCell>{valueText}</TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={2}>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary", fontStyle: "italic" }}
                    >
                      {t("No configurations available")}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  );
};
